import { render } from "./AggiungiFoto.vue?vue&type=template&id=33f40ba9"
import script from "./AggiungiFoto.vue?vue&type=script&lang=js"
export * from "./AggiungiFoto.vue?vue&type=script&lang=js"

import "./AggiungiFoto.vue?vue&type=style&index=0&id=33f40ba9&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__